function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* replacement start */

var _require = require('buffer'),
  Buffer = _require.Buffer;
'use strict';
var _require2 = require('./ours/primordials'),
  ObjectDefineProperty = _require2.ObjectDefineProperty,
  ObjectKeys = _require2.ObjectKeys,
  ReflectApply = _require2.ReflectApply;
var _require3 = require('./ours/util'),
  customPromisify = _require3.promisify.custom;
var _require4 = require('./internal/streams/operators'),
  streamReturningOperators = _require4.streamReturningOperators,
  promiseReturningOperators = _require4.promiseReturningOperators;
var _require5 = require('./ours/errors'),
  ERR_ILLEGAL_CONSTRUCTOR = _require5.codes.ERR_ILLEGAL_CONSTRUCTOR;
var compose = require('./internal/streams/compose');
var _require6 = require('./internal/streams/state'),
  setDefaultHighWaterMark = _require6.setDefaultHighWaterMark,
  getDefaultHighWaterMark = _require6.getDefaultHighWaterMark;
var _require7 = require('./internal/streams/pipeline'),
  pipeline = _require7.pipeline;
var _require8 = require('./internal/streams/destroy'),
  destroyer = _require8.destroyer;
var eos = require('./internal/streams/end-of-stream');
var internalBuffer = {};
var promises = require('./stream/promises');
var utils = require('./internal/streams/utils');
var Stream = module.exports = require('./internal/streams/legacy').Stream;
Stream.isDestroyed = utils.isDestroyed;
Stream.isDisturbed = utils.isDisturbed;
Stream.isErrored = utils.isErrored;
Stream.isReadable = utils.isReadable;
Stream.isWritable = utils.isWritable;
Stream.Readable = require('./internal/streams/readable');
var _iterator = _createForOfIteratorHelper(ObjectKeys(streamReturningOperators)),
  _step;
try {
  var _loop = function _loop() {
    var key = _step.value;
    var op = streamReturningOperators[key];
    function fn() {
      if (this instanceof fn ? this.constructor : void 0) {
        throw ERR_ILLEGAL_CONSTRUCTOR();
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return Stream.Readable.from(ReflectApply(op, this, args));
    }
    ObjectDefineProperty(fn, 'name', {
      __proto__: null,
      value: op.name
    });
    ObjectDefineProperty(fn, 'length', {
      __proto__: null,
      value: op.length
    });
    ObjectDefineProperty(Stream.Readable.prototype, key, {
      __proto__: null,
      value: fn,
      enumerable: false,
      configurable: true,
      writable: true
    });
  };
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    _loop();
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}
var _iterator2 = _createForOfIteratorHelper(ObjectKeys(promiseReturningOperators)),
  _step2;
try {
  var _loop2 = function _loop2() {
    var key = _step2.value;
    var op = promiseReturningOperators[key];
    function fn() {
      if (this instanceof fn ? this.constructor : void 0) {
        throw ERR_ILLEGAL_CONSTRUCTOR();
      }
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return ReflectApply(op, this, args);
    }
    ObjectDefineProperty(fn, 'name', {
      __proto__: null,
      value: op.name
    });
    ObjectDefineProperty(fn, 'length', {
      __proto__: null,
      value: op.length
    });
    ObjectDefineProperty(Stream.Readable.prototype, key, {
      __proto__: null,
      value: fn,
      enumerable: false,
      configurable: true,
      writable: true
    });
  };
  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
    _loop2();
  }
} catch (err) {
  _iterator2.e(err);
} finally {
  _iterator2.f();
}
Stream.Writable = require('./internal/streams/writable');
Stream.Duplex = require('./internal/streams/duplex');
Stream.Transform = require('./internal/streams/transform');
Stream.PassThrough = require('./internal/streams/passthrough');
Stream.pipeline = pipeline;
var _require9 = require('./internal/streams/add-abort-signal'),
  addAbortSignal = _require9.addAbortSignal;
Stream.addAbortSignal = addAbortSignal;
Stream.finished = eos;
Stream.destroy = destroyer;
Stream.compose = compose;
Stream.setDefaultHighWaterMark = setDefaultHighWaterMark;
Stream.getDefaultHighWaterMark = getDefaultHighWaterMark;
ObjectDefineProperty(Stream, 'promises', {
  __proto__: null,
  configurable: true,
  enumerable: true,
  get: function get() {
    return promises;
  }
});
ObjectDefineProperty(pipeline, customPromisify, {
  __proto__: null,
  enumerable: true,
  get: function get() {
    return promises.pipeline;
  }
});
ObjectDefineProperty(eos, customPromisify, {
  __proto__: null,
  enumerable: true,
  get: function get() {
    return promises.finished;
  }
});

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;
Stream._isUint8Array = function isUint8Array(value) {
  return value instanceof Uint8Array;
};
Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};